module.exports = __webpack_public_path__ + "static/media/video_3.167cd2b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/video_3.mp4
// module id = cIKL
// module chunks = 0